module.exports = __webpack_public_path__ + "img/btn_start1.2c8738ad.png";